module.exports = __webpack_public_path__ + "img/II-36.db5122b9.svg";